import "./App.css";
import React from "react";
import Navbar from "./components/Navbar/Navbar";
import Header from "./components/Header/Header";
import Content from "./components/Content/Content";
// import Headbar from "./Headbar/Headbar";
// import Products from "./product/product";
// import Item from './Item';
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const App = () => {
  return (
    <>
    <div className="body">
      {/* <CartProvider> */}
      <Navbar/>
      <Header/>
      <Content/>
      {/* <Headbar/> */}
      {/* <Product/> */}
      {/* <Router>
      <Headbar />
        <Switch>
        <Route exact path="/" >
          
          <Products />
      
        </Route>
          <Route path="/item" >
          <Item />
          </Route>
      
        </Switch>
      </Router> */}
      </div>
    </>
  );
};

export default App;
